import React from 'react';

export const DeleteBlueIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M8.5 5.06098H11.5C11.5 4.25275 10.8285 3.59756 10 3.59756C9.17155 3.59756 8.5 4.25275 8.5 5.06098ZM7.375 5.06098C7.375 3.64659 8.55025 2.5 10 2.5C11.4497 2.5 12.625 3.64659 12.625 5.06098H16.9375C17.2481 5.06098 17.5 5.30668 17.5 5.60976C17.5 5.91284 17.2481 6.15854 16.9375 6.15854H15.9482L15.0692 15.0204C14.9297 16.4269 13.7181 17.5 12.2697 17.5H7.73027C6.28191 17.5 5.07036 16.4269 4.93085 15.0204L4.05181 6.15854H3.0625C2.75184 6.15854 2.5 5.91284 2.5 5.60976C2.5 5.30668 2.75184 5.06098 3.0625 5.06098H7.375ZM8.875 8.53659C8.875 8.23351 8.62315 7.9878 8.3125 7.9878C8.00184 7.9878 7.75 8.23351 7.75 8.53659V14.0244C7.75 14.3275 8.00184 14.5732 8.3125 14.5732C8.62315 14.5732 8.875 14.3275 8.875 14.0244V8.53659ZM11.6875 7.9878C11.3769 7.9878 11.125 8.23351 11.125 8.53659V14.0244C11.125 14.3275 11.3769 14.5732 11.6875 14.5732C11.9981 14.5732 12.25 14.3275 12.25 14.0244V8.53659C12.25 8.23351 11.9981 7.9878 11.6875 7.9878Z"
      fill="#27B0E0"
    />
  </svg>
);
